export const StorageKeys = {
  USER_IDEA: 'market_discovery_user_idea',
  CONVERSATION_HISTORY: 'market_discovery_conversation',
  CONFIRMED_MARKET: 'market_discovery_confirmed_market',
  SEGMENTATION_TREES: 'market_discovery_segmentation_trees',
  SELECTED_SEGMENTS: 'market_discovery_selected_segments',
  CURRENT_STEP: 'market_discovery_current_step'
};

export const saveToStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    console.error('Failed to save to localStorage:', error);
  }
};

export const loadFromStorage = (key, defaultValue = null) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error('Failed to load from localStorage:', error);
    return defaultValue;
  }
};

export const removeFromStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Failed to remove from localStorage:', error);
  }
};

export const clearAllStorage = () => {
  try {
    Object.values(StorageKeys).forEach(key => {
      localStorage.removeItem(key);
    });
  } catch (error) {
    console.error('Failed to clear localStorage:', error);
  }
};

export const getProgressData = () => {
  return {
    userIdea: loadFromStorage(StorageKeys.USER_IDEA),
    conversationHistory: loadFromStorage(StorageKeys.CONVERSATION_HISTORY, []),
    confirmedMarket: loadFromStorage(StorageKeys.CONFIRMED_MARKET),
    segmentationTrees: loadFromStorage(StorageKeys.SEGMENTATION_TREES),
    selectedSegments: loadFromStorage(StorageKeys.SELECTED_SEGMENTS, []),
    currentStep: loadFromStorage(StorageKeys.CURRENT_STEP, 1)
  };
};